import React, { Fragment, useState, useEffect, useCallback, useRef } from "react";
import Slider from "react-slick";
import Modal from 'react-modal';
import { Carousel as Lightbox } from 'react-responsive-carousel';
import { useSelector, useDispatch } from 'react-redux';
import { show, setCurrentIndex } from '../Actions/LightboxImages.action';

export default function ProductSlider(props) {

    const dispatch = useDispatch();
    const { visible, index } = useSelector((state) => state.lightboxImages);
    const onClose = useCallback(() => dispatch(show(false)), [dispatch]);
    const onClickThumbnail = (index) => {
        dispatch(show(true));
        dispatch(setCurrentIndex(index));
    };

    const sliderRef = useRef();

    var next = () => {
        sliderRef.current.slickNext();
    }
    var previous = () => {
        sliderRef.current.slickPrev();
    }

    const customStyles = {
        content: {
            background: 'none',
            padding: 0,
            border: 'none',
        },
        overlay: {
            background: 'rgba(0, 0, 0, 0.8)',
            zIndex: 2003,
        },
    };

    const settings = {
        dots: true,      
        infinite: true,
        speed: 500,
        lazyLoad: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: dots => (
            <div className="custom-slider-controls">
                <button type="button" data-role="none" className="slick-arrow slick-prev" onClick={() => previous()}> Previous</button>
                    <ul className="slick-dots-wrapper">{dots}</ul>
                <button type="button" data-role="none" className="slick-arrow slick-next" onClick={() => next()}> Next</button>       
            </div>
        )};
    
    const LightboxSettings = {
        showStatus: false,
        showIndicators: false,
        useKeyboardArrows: true,
        thumbWidth: 50,
        autoPlay: false,
        autoFocus: true,
        customPaging: function(slide) {
            return (
              <a>
                <img src={`${props.children[slide].dataset.src}`} />
              </a>
            );
          },
        dots: true,
        dotsClass: "slick-dots",
    };

    var getImages = () => {
        return props.children.map((child, i) => {
            return <div data-src={child.dataset.src} itemProp="url" onClick={() => onClickThumbnail(i)} dangerouslySetInnerHTML={{__html: child.innerHTML}} key={"product-page-carousel__image-" + i}></div>
        });
    }

    useEffect(() => {
        const placeholder = document?.querySelector(".product-page-carousel__placeholder");
        if(placeholder){
            placeholder.remove();
        }
    },[])

    return(
        <>
        {/* <a className="product-page-carousel__icon" href="#"><i className="product-page-carousel__icon--wishlist"></i></a> */}
        <Slider ref={sliderRef} {...settings}>
            {getImages()}
        </Slider>
        <Modal
        ariaHideApp={false}
        preventScroll={true}
        isOpen={visible}
        onRequestClose={onClose}
        style={customStyles}
        shouldCloseOnOverlayClick={true}>
            <Slider
                {...LightboxSettings}
                initialSlide={index}
                className="light-box"
                >
                    {props.children.map((value, index) => (
                        <div
                            key={`figure${index}`}
                            className="light-box__container"
                        >
                            <img src={value.dataset.src} className="light-box__image"></img> 

                        </div>
                    ))}

            </Slider>
            <button
            onClick={onClose}
            className="light-box__close-btn"
            >
             &times;
        </button>
    </Modal>
        </>
    );
}